// src/extenders/drawer-popover.js
var DrawerPopover = class extends HTMLElement {
  constructor() {
    super();
    this.trigger = document.getElementById(this.getAttribute("aria-controlledby"));
    if (this.trigger === null) {
      return;
    }
    this.openIcon = this.trigger.querySelector(".drawer-open");
    this.closeIcon = this.trigger.querySelector(".drawer-close");
    for (const internalCloseButtton of this.querySelectorAll("[data-drawer-close]")) {
      internalCloseButtton.addEventListener("click", this._closeDrawer.bind(this));
    }
  }
  connectedCallback() {
    if (this.trigger === null) {
      return;
    }
    this.trigger.addEventListener("click", this._toggleDrawer.bind(this));
    for (const internalCloseButtton of this.querySelectorAll("[data-drawer-close]")) {
      internalCloseButtton.addEventListener("click", this._closeDrawer.bind(this));
    }
  }
  _toggleDrawer() {
    if (this.hasAttribute("open")) {
      this._closeDrawer();
    } else {
      this._openDrawer();
    }
  }
  _openDrawer() {
    var _a, _b;
    (_a = this.closeIcon) == null ? void 0 : _a.classList.remove("hidden");
    (_b = this.openIcon) == null ? void 0 : _b.classList.add("hidden");
    this.setAttribute("open", "");
    this.classList.remove("translate-x-full");
    this.setAttribute("aria-hidden", "false");
    this.dispatchEvent(new CustomEvent("drawer:open"));
    document.documentElement.classList.add("overflow-hidden");
  }
  _closeDrawer() {
    var _a, _b;
    (_a = this.closeIcon) == null ? void 0 : _a.classList.add("hidden");
    (_b = this.openIcon) == null ? void 0 : _b.classList.remove("hidden");
    this.removeAttribute("open");
    this.classList.add("translate-x-full");
    this.setAttribute("aria-hidden", "true");
    this.dispatchEvent(new CustomEvent("drawer:close"));
    document.documentElement.classList.remove("overflow-hidden");
  }
};
if (!window.customElements.get("drawer-popover")) {
  window.customElements.define("drawer-popover", DrawerPopover);
}
var SidebarNavigation = class extends DrawerPopover {
  constructor() {
    super();
    this.buttons = this.querySelectorAll("button[data-to]");
    this.currentPage = 1;
    this.previousSlide = this.querySelector('[data-layer="1"]');
    for (const button of this.buttons) {
      button.addEventListener("click", (e) => this.changeActiveSlide(e));
    }
    this.addEventListener("drawer:open", this._setOpenState.bind(this));
    this.addEventListener("drawer:close", this._setClosedState.bind(this));
  }
  changeActiveSlide(e) {
    const target = e.target.nodeName === "BUTTON" ? e.target : e.target.closest("button");
    if (!(target == null ? void 0 : target.hasAttribute("data-to"))) {
      return;
    }
    const targetPage = parseInt(target.getAttribute("data-to"));
    const forwards = targetPage > this.currentPage;
    this.currentPage = targetPage;
    let targetSlide = null;
    if (targetPage === 1) {
      targetSlide = this.querySelector('[data-layer="1"]');
      this._showHideLayers(targetSlide, forwards);
      return;
    }
    targetSlide = this.querySelector(`[data-layer="${targetPage}"][data-current="${target.getAttribute("data-target")}"]`);
    if (!targetSlide) {
      return;
    }
    this._showHideLayers(targetSlide, forwards);
  }
  _showHideLayers(activeSlide, forwards) {
    if (!activeSlide || !this.previousSlide) {
      return;
    }
    activeSlide.classList.remove("translate-x-full", "overflow-hidden");
    activeSlide.classList.add("overflow-auto");
    activeSlide.setAttribute("tabindex", "-1");
    activeSlide.setAttribute("aria-hidden", "false");
    activeSlide.focus();
    if (!forwards) {
      this.previousSlide.classList.add("translate-x-full");
    }
    this.previousSlide.classList.remove("overflow-auto");
    this.previousSlide.classList.add("overflow-hidden");
    this.previousSlide.removeAttribute("tabindex");
    this.previousSlide.setAttribute("aria-hidden", "true");
    this.previousSlide = activeSlide;
  }
  _setOpenState() {
    var _a, _b, _c;
    this._resetLayers();
    (_a = this.previousSlide) == null ? void 0 : _a.setAttribute("tabindex", "-1");
    (_b = this.previousSlide) == null ? void 0 : _b.setAttribute("aria-hidden", "false");
    (_c = this.previousSlide) == null ? void 0 : _c.focus();
  }
  _setClosedState() {
    var _a, _b;
    this._resetLayers();
    (_a = this.previousSlide) == null ? void 0 : _a.removeAttribute("tabindex");
    (_b = this.previousSlide) == null ? void 0 : _b.setAttribute("aria-hidden", "true");
  }
  _resetLayers() {
    const firstLayer = this.querySelector('[data-layer="1"]');
    for (const layer of this.querySelectorAll("[data-layer]")) {
      layer.classList.remove("overflow-auto");
      layer.classList.add("overflow-hidden");
      layer.removeAttribute("tabindex");
      layer.setAttribute("aria-hidden", "true");
      if (layer !== firstLayer) {
        layer.classList.add("translate-x-full");
      }
    }
    firstLayer == null ? void 0 : firstLayer.classList.remove("translate-x-full", "overflow-hidden");
    firstLayer == null ? void 0 : firstLayer.classList.add("overflow-auto");
    this.currentPage = 1;
    this.previousSlide = firstLayer;
  }
};
if (!window.customElements.get("sidebar-navigation")) {
  window.customElements.define("sidebar-navigation", SidebarNavigation);
}
